import { createFileRoute, useParams } from '@tanstack/react-router';

import { SettingsTab } from '@/views/admin/courses/tabs/settings-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/settings')({
  component: SettingsRoute,
});

function SettingsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/settings' });
  return <SettingsTab id={id} />;
}
